import { EmployeePolicy } from '@domain/access-control/types/employee-subject';
import { MANAGER_ROLES } from '@domain/access-control/types/employee-roles';

/**
 * Managers get the team-wide prospects dashboard. All other roles work with
 * their own prospect list. This includes users with no employee record.
 */
export const canViewTeamProspects: EmployeePolicy = ({ role }) =>
  role !== null && MANAGER_ROLES.has(role);
